import { Component } from '@angular/core';

@Component({
    selector: 'app-manager-dashboard-page',
    template: ` <app-dashboard-page> </app-dashboard-page> `,
    styles: [``],
    standalone: false
})
export class ManagerDashboardPageComponent {
  constructor() {}
}
